enum Tables {
    Files = "files",
    Instruments = "instruments",
    Pgmigrations = "pgmigrations",
    Projects = "projects",
    TrackSectionSteps = "track_section_steps",
    TrackSections = "track_sections",
    Tracks = "tracks",
    Users = "users",
}

export { Tables };
